<template>
  <ul class="navbar-link-list">
    <li v-for="(item, index) in links" :key="index">
      <ZtLink :to="item?.link?.url?.path">
        {{ item.link.label }}
      </ZtLink>
    </li>
  </ul>
</template>

<script lang="ts" setup>
import type { MenuLinkTreeFirstFragment } from '#graphql-operations'

withDefaults(
  defineProps<{
    links: MenuLinkTreeFirstFragment[]
  }>(),
  {
    links: () => [],
  },
)
</script>

<style>
@reference '~/assets/css/tailwind.css';
.navbar-link-list {
  @apply desktop:text-size-6;
  @apply widescreen:text-size-5;

  a {
    @apply text-muted;
    line-height: 1.579;

    &:hover {
      @apply text-scheme-invert-bis;
    }
    &.nuxt-link-exact-active {
      @apply text-scheme-invert;
    }
  }
}
</style>
